import React from "react"
import classnames from "classnames"
import './styles.scss'

const component = (props) => {
  let {url, controlless, ...otherProps} = props;

  // treat as controlless if that prop exists, even if its value is undefined
  controlless = 'controlless' in props;

  return (
    <div className={classnames("h5-embed", {"h5-embed--controlless": controlless})}>
      <iframe className="h5-embed__iframe" src={url} {...otherProps} />
    </div>
  )
}

component.displayName = 'H5Embed';
export default component;


// WEBPACK FOOTER //
// ./client/components/H5Embed/index.js